// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ISearchOrganizationDto
 */
export interface ISearchOrganizationDto {
    /**
     * 
     * @type {Set<number>}
     * @memberof ISearchOrganizationDto
     */
    ids?: Set<number>;
    /**
     * 
     * @type {number}
     * @memberof ISearchOrganizationDto
     */
    partner_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ISearchOrganizationDto
     */
    parent_id?: number;
    /**
     * 
     * @type {Set<number>}
     * @memberof ISearchOrganizationDto
     */
    parent_ids?: Set<number>;
    /**
     * 
     * @type {Set<string>}
     * @memberof ISearchOrganizationDto
     */
    type?: Set<ISearchOrganizationDtoTypeEnum>;
    /**
     * 
     * @type {Set<string>}
     * @memberof ISearchOrganizationDto
     */
    statuses?: Set<ISearchOrganizationDtoStatusesEnum>;
    /**
     * 
     * @type {string}
     * @memberof ISearchOrganizationDto
     */
    search_value?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof ISearchOrganizationDto
     */
    organization_types?: Set<ISearchOrganizationDtoOrganizationTypesEnum>;
}

/**
* @export
* @enum {string}
*/
export enum ISearchOrganizationDtoTypeEnum {
    SYSTEM = 'SYSTEM',
    PARTNER = 'PARTNER',
    DISTRIBUTOR = 'DISTRIBUTOR',
    COMPANY = 'COMPANY',
    SUBSIDIARY = 'SUBSIDIARY',
    SUBGROUP = 'SUBGROUP'
}
/**
* @export
* @enum {string}
*/
export enum ISearchOrganizationDtoStatusesEnum {
    PENDING = 'PENDING',
    ACTIVE = 'ACTIVE',
    TERMINATED = 'TERMINATED',
    ACTIVATION_FAILED = 'ACTIVATION_FAILED',
    PENDING_TERMINATION = 'PENDING_TERMINATION',
    EXPRESS_SETUP = 'EXPRESS_SETUP',
    ABANDONED = 'ABANDONED',
    TERMINATION_IN_PROGRESS = 'TERMINATION_IN_PROGRESS',
    PENDING_REACTIVATION = 'PENDING_REACTIVATION'
}
/**
* @export
* @enum {string}
*/
export enum ISearchOrganizationDtoOrganizationTypesEnum {
    SYSTEM = 'SYSTEM',
    PARTNER = 'PARTNER',
    DISTRIBUTOR = 'DISTRIBUTOR',
    COMPANY = 'COMPANY',
    SUBSIDIARY = 'SUBSIDIARY',
    SUBGROUP = 'SUBGROUP'
}


/**
 * Check if a given object implements the ISearchOrganizationDto interface.
 */
export function instanceOfISearchOrganizationDto(value: object): value is ISearchOrganizationDto {
    return true;
}

export function ISearchOrganizationDtoFromJSON(json: any): ISearchOrganizationDto {
    return ISearchOrganizationDtoFromJSONTyped(json, false);
}

export function ISearchOrganizationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ISearchOrganizationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'] == null ? undefined : new Set(json['ids']),
        'partner_id': json['partner_id'] == null ? undefined : json['partner_id'],
        'parent_id': json['parent_id'] == null ? undefined : json['parent_id'],
        'parent_ids': json['parent_ids'] == null ? undefined : new Set(json['parent_ids']),
        'type': json['type'] == null ? undefined : new Set(json['type']),
        'statuses': json['statuses'] == null ? undefined : new Set(json['statuses']),
        'search_value': json['search_value'] == null ? undefined : json['search_value'],
        'organization_types': json['organization_types'] == null ? undefined : new Set(json['organization_types']),
    };
}

export function ISearchOrganizationDtoToJSON(json: any): ISearchOrganizationDto {
    return ISearchOrganizationDtoToJSONTyped(json, false);
}

export function ISearchOrganizationDtoToJSONTyped(value?: ISearchOrganizationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'] == null ? undefined : Array.from(value['ids'] as Set<any>),
        'partner_id': value['partner_id'],
        'parent_id': value['parent_id'],
        'parent_ids': value['parent_ids'] == null ? undefined : Array.from(value['parent_ids'] as Set<any>),
        'type': value['type'] == null ? undefined : Array.from(value['type'] as Set<any>),
        'statuses': value['statuses'] == null ? undefined : Array.from(value['statuses'] as Set<any>),
        'search_value': value['search_value'],
        'organization_types': value['organization_types'] == null ? undefined : Array.from(value['organization_types'] as Set<any>),
    };
}

